import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["workOrderNum", "workOrderReceived", "stakeMission", "customerRequest", "submitBtn", "errors"]
  static values = { updateUrl: String }

  async save() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    this._hideErrors()
    this.submitBtnTarget.disabled = true
    this.submitBtnTarget.textContent = "Saving..."

    const woNum = this.workOrderNumTarget.value
    const woReceived = this.workOrderReceivedTarget.value
    const stake = this.stakeMissionTarget.value
    const customerRequest = this.customerRequestTarget.value

    try {
      const response = await fetch(this.updateUrlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({
          project: {
            work_order_num: woNum,
            work_order_received: woReceived,
            stake_mission: stake,
            customer_request: customerRequest
          }
        })
      })

      const data = await response.json()

      if (response.ok && data.success) {
        // Optimistic DOM update
        const card = document.getElementById("re-details-card-body")
        if (card) {
          this._updateField(card, "work-order-num", woNum)
          this._updateField(card, "work-order-received", woReceived ? this._formatDate(woReceived) : "")
          this._updateField(card, "stake-mission", stake)
          this._updateField(card, "customer-request", customerRequest)
        }

        // Update header WO# badge
        const badge = document.querySelector("[data-project-number]")
        if (badge) badge.textContent = woNum || ""

        this._closeModal()
        this._showFlash("Settings updated successfully.")
      } else {
        this._showErrors(data.errors || ["Update failed"])
      }
    } catch {
      this._showErrors(["A network error occurred. Please try again."])
    } finally {
      this.submitBtnTarget.disabled = false
      this.submitBtnTarget.textContent = "Save Changes"
    }
  }

  _updateField(container, fieldName, value) {
    const el = container.querySelector(`[data-field="${fieldName}"]`)
    if (el) el.textContent = value || "—"
  }

  _formatDate(dateStr) {
    if (!dateStr) return ""
    const d = new Date(dateStr + "T00:00:00")
    return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" })
  }

  _showErrors(messages) {
    if (!this.hasErrorsTarget) return
    this.errorsTarget.innerHTML = messages.map(m => `<p>${m}</p>`).join("")
    this.errorsTarget.classList.remove("hidden")
  }

  _hideErrors() {
    if (!this.hasErrorsTarget) return
    this.errorsTarget.classList.add("hidden")
    this.errorsTarget.innerHTML = ""
  }

  _closeModal() {
    this.element.classList.add("hidden")
    document.body.style.overflow = ""
  }

  _showFlash(message) {
    const container = document.createElement("div")
    container.className = "flash-toast-notice"
    container.dataset.controller = "flash"
    container.dataset.flashDismissAfterValue = "5000"
    container.setAttribute("role", "alert")

    const iconDiv = document.createElement("div")
    iconDiv.className = "shrink-0"
    iconDiv.innerHTML = `<svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>`

    const msgEl = document.createElement("p")
    msgEl.className = "flex-1 text-sm"
    msgEl.textContent = message

    container.appendChild(iconDiv)
    container.appendChild(msgEl)
    document.body.insertBefore(container, document.body.firstChild)
  }
}
